import React from "react";
import { useAuth } from "../context/AuthContext";
import AuthGate from "./AuthGate";

/**
 * V2Gate — keeps the URL pinned at /v2 (or any /v2/* sub-route) while the
 * user is unauthenticated. Renders the V2 dark login/register surface inline
 * instead of redirecting to the V1 /login page. This is critical for the
 * Play Store TWA: the installed app launches at start_url=/v2 and must show
 * a proper auth screen there without bouncing to a desktop-styled page.
 *
 * On successful login, AuthContext sets `user` to the new user object,
 * this component re-renders, and the children (MobileShell) are mounted.
 */
export default function V2Gate({ children }) {
  const { user } = useAuth();

  // null = AuthContext is still hydrating from /auth/me — avoid flicker.
  if (user === null) {
    return (
      <div
        data-testid="v2-gate-loading"
        className="fixed inset-0 z-40 bg-[#070710] flex items-center justify-center"
      >
        <div className="font-mono text-[#7C3AED] text-xs tracking-[0.3em] uppercase animate-pulse">
          [ loading session ]
        </div>
      </div>
    );
  }

  if (user === false) return <AuthGate />;
  return children;
}
